// extracted by mini-css-extract-plugin
module.exports = {"display_inline":"WorkGroupingsOverview_display_inline__wOM66","workgroupings_flex":"WorkGroupingsOverview_workgroupings_flex___x0ph"};